<template>
  <div style="display: flex; flex-wrap: wrap; width: auto; height: auto;">
    <div class="mapHolder">
      <l-map
        ref="map"
        style="height: 100%; width: 100%;"
        :zoom="zoom"
        :center="mapCenter"
        :options="{zoomControl: false}"
        :maxZoom="max"
        @update:zoom="zoomUpdated"
        @update:center="centerUpdated"
        @update:bounds="boundsUpdated"
      >
        <l-tile-layer :url="url"></l-tile-layer>
        <l-control-zoom position="topright"></l-control-zoom>
        <v-marker-cluster
          ref="clusterGroup"
          :options="{singleMarkerMode: true, showCoverageOnHover: false, disableClusteringAtZoom: 19, spiderfyOnMaxZoom: false, zoomToBoundsOnClick: true, maxClusterRadius: 50}"
        >
          <div>
            <l-marker
              v-for="(marker, index) in projects"
              :key="index"
              :lat-lng="[marker.geometry.coordinates[1], marker.geometry.coordinates[0]]"
            ></l-marker>
          </div>
        </v-marker-cluster>
      </l-map>
    </div>
    <div class="contHolder">
      <b-nav :justified="true" pills>
        <b-nav-item @click="changeActive" :active="this.ola">Όλα</b-nav-item>
        <b-nav-item @click="changeActive" :active="this.public">Δημόσιος Τομέας - Ελλάδα</b-nav-item>
        <b-nav-item @click="changeActive" :active="this.international">Διεθνής Αγορά</b-nav-item>
        <b-nav-item @click="changeActive" :active="this.development">Έρευνα και Ανάπτυξη</b-nav-item>
        <b-nav-item @click="changeActive" :active="this.privateSector">Ιδιωτικός Τομέας</b-nav-item>
      </b-nav>
      <div class="contItems" id="style-3">
        <div class="hold" v-for="(value, index) in filteredData" :key="index">
          <p class="title">
            <b>{{value.properties.title}}</b>
          </p>
          <ul class="subtitle">
            <li>{{value.properties.field_project_category}}</li>
          </ul>
          <img class="imgholder" :src="value.properties.field_image" />
          <p class="linktab">
            <a :href="value.properties.Nid" target='_blank'>Περισσότερα</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import {
  LMap,
  LTileLayer,
  LControlZoom,
  LMarker,
  LIcon,
  LPolygon,
} from "vue2-leaflet";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import L from "leaflet";
import * as turf from "@turf/turf";

export default {
  name: "MyMap",
  components: {
    LMap,
    LTileLayer,
    LControlZoom,
    LMarker,
    LIcon,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
    LPolygon,
  },
  props: ["fotismos_topo", "municipalities", "projects", "featureCol"],
  data() {
    return {
      zoom: 5,
      max: 13,
      center: [43.866218006556394, 12.502441406250002],
      url:
        "https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png",
      ola: true,
      public: false,
      international: false,
      development: false,
      privateSector: false,
      styleDhmoi: {
        color: "#A9A9A9",
        fillColor: "#A9A9A900",
        weight: 0.5,
        opacity: 0.8,
      },
      polygon: {
        latlngs: [],
        color: "green",
        fillColor: "green",
      },
      projWithinBounds: null,
      filteredData: null,
      windowWidth: null
    };
  },
  methods: {
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;

      let polygon = turf.polygon([
        [
          [bounds._southWest.lng, bounds._southWest.lat],
          [bounds._southWest.lng, bounds._northEast.lat],
          [bounds._northEast.lng, bounds._northEast.lat],
          [bounds._northEast.lng, bounds._southWest.lat],
          [bounds._southWest.lng, bounds._southWest.lat],
        ],
      ]);

      this.projWithinBounds = turf.pointsWithinPolygon(
        this.featureCol,
        polygon
      );
    },
    getUrl(data) {
      return data.properties.image;
    },
    changeActive(e) {
      switch (e.target.text) {
        case "Όλα":
          this.ola = true;
          this.public = false;
          this.international = false;
          this.development = false;
          this.privateSector = false;
          break;
        case "Δημόσιος Τομέας - Ελλάδα":
          this.ola = false;
          this.public = true;
          this.international = false;
          this.development = false;
          this.privateSector = false;
          break;
        case "Διεθνής Αγορά":
          this.ola = false;
          this.public = false;
          this.international = true;
          this.development = false;
          this.privateSector = false;
          break;
        case "Έρευνα και Ανάπτυξη":
          this.ola = false;
          this.public = false;
          this.international = false;
          this.development = true;
          this.privateSector = false;
          break;
        case "Ιδιωτικός Τομέας":
          this.ola = false;
          this.public = false;
          this.international = false;
          this.development = false;
          this.privateSector = true;
          break;
      }

      if (this.ola) {
        this.filteredData = this.projWithinBounds.features;
      } else if (this.public) {
        this.filteredData = this.projWithinBounds.features.filter(
          (el) =>
            el.properties.field_project_category == "Δημόσιος Τομέας - Ελλάδα"
        );
      } else if (this.international) {
        this.filteredData = this.projWithinBounds.features.filter(
          (el) => el.properties.field_project_category == "Διεθνής Αγορά"
        );
      } else if (this.development) {
        this.filteredData = this.projWithinBounds.features.filter(
          (el) => el.properties.field_project_category == "Έρευνα και Ανάπτυξη"
        );
      } else if (this.privateSector) {
        this.filteredData = this.projWithinBounds.features.filter(
          (el) => el.properties.field_project_category == "Ιδιωτικός Τομέας"
        );
      }
    },
    getGeojson(e) {
      let bounds = [];
      bounds.push(e.layer._bounds._northEast);
      bounds.push(e.layer._bounds._southWest);
      this.$refs.map.mapObject.fitBounds(bounds);
    },
  },
  computed: {
    mapCenter: function () {
      if (this.windowWidth < 800) {
        return [39.16414104768742, 22.321993710277773];
      } else {
        return [43.866218006556394, 12.502441406250002];
      }
    }
  },
  watch: {
    municipalities: function (data) {
      let vm = this;
      L.geoJson(data, {
        style: function (feature) {
          return {
            color: "gray",
            opacity: 0.5,
            weight: 1,
            fillColor: "#00000000",
          };
        },
        onEachFeature: function (feature, layer) {
          let label = `${feature.properties.NAME_GR}`;
          layer.bindTooltip(label, {
            sticky: true,
          });
          layer.on("click", function () {
            let bounds = [];
            bounds.push(layer._bounds._northEast);
            bounds.push(layer._bounds._southWest);
            vm.$refs.map.mapObject.fitBounds(bounds);
          });
          layer.on("mouseover", function () {
            layer.setStyle({
              fillColor: "gray",
              opacity: 0.7,
              weight: 3,
            });
          });
          layer.on("mouseout", function () {
            layer.setStyle({
              fillColor: "#00000000",
              opacity: 0.5,
              weight: 1,
            });
          });
        },
      }).addTo(this.$refs.map.mapObject);
    },
    projWithinBounds: function (data) {
      if (this.ola) {
        this.filteredData = data.features;
      } else if (this.public) {
        this.filteredData = data.features.filter(
          (el) =>
            el.properties.field_project_category == "Δημόσιος Τομέας - Ελλάδα"
        );
      } else if (this.international) {
        this.filteredData = data.features.filter(
          (el) => el.properties.field_project_category == "Διεθνής Αγορά"
        );
      } else if (this.development) {
        this.filteredData = data.features.filter(
          (el) => el.properties.field_project_category == "Έρευνα και Ανάπτυξη"
        );
      } else if (this.privateSector) {
        this.filteredData = data.features.filter(
          (el) => el.properties.field_project_category == "Ιδιωτικός Τομέας"
        );
      }
    },
    projects: function (data) {
      console.log(data);
    },
    featureCol: function (data) {
      let bounds = this.$refs.map.mapObject.getBounds();
      let polygon = turf.polygon([
        [
          [bounds._southWest.lng, bounds._southWest.lat],
          [bounds._southWest.lng, bounds._northEast.lat],
          [bounds._northEast.lng, bounds._northEast.lat],
          [bounds._northEast.lng, bounds._southWest.lat],
          [bounds._southWest.lng, bounds._southWest.lat],
        ],
      ]);

      this.projWithinBounds = turf.pointsWithinPolygon(data, polygon);
    },
  },
  mounted() {
    this.windowWidth = window.innerWidth;
  },
  updated() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mapHolder {
  position: relative;
  width: 60%;
  height: 700px;
  float: left;
}

.contHolder {
  position: relative;
  width: 40%;
  float: right;
  font-size: 14px;
  padding: 10px;
}

.contItems {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  justify-content: space-between;
  margin-top: 10px;
  width: 100%;
  max-height: 600px;
  height: auto;
  padding: 10px;
  overflow-y: scroll;
}

.imgholder {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  width: 150px;
  position: relative;
}

.linktab {
  margin-top: 30px;
  margin-left: 15px;
  cursor: pointer;
  width: auto;
}

.title {
  margin-bottom: 10px;
  color: rgb(225, 84, 33);
}

.subtitle {
  margin-bottom: 35px;
  color: rgb(225, 84, 33);
  list-style: square;
}

.hold {
  flex-basis: 40%;
  margin-left: 20px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #e15421;
  margin-right: 20px;
}

.linktab:hover {
  color: rgb(225, 84, 33);
}


@media only screen and (max-width: 1245px) {
.mapHolder {
  width: 100%;
}

.contHolder {
  width: 100%;
}

.hold {
  flex-basis: 40%;
  margin-left: 5px;
  margin-bottom: 5px;
  padding-bottom: 1px;
  border-bottom: 1px dashed #e15421;
  margin-right: 5px;
}

}

@media only screen and (max-width: 780px) {
.mapHolder {
  width: 100%;
  height: 350px;
}

.contHolder {
  width: 100%;
}

.hold {
  flex-basis: 40%;
  margin-left: 5px;
  margin-bottom: 5px;
  padding-bottom: 1px;
  border-bottom: 1px dashed #e15421;
  margin-right: 5px;
}

}


@media only screen and (max-width: 450px) {
.mapHolder {
  width: 100%;
  height: 300px;
}

ul {
  margin: 5px;
  padding: 0;
}

.contHolder {
  width: 100%;
}

.hold {
  flex-basis: 40%;
  margin-left: 5px;
  margin-bottom: 5px;
  padding-bottom: 1px;
  border-bottom: 1px dashed #e15421;
  margin-right: 5px;
}

.imgholder {
  width: 100px;
}
.contItems {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  justify-content: space-between;
  margin-top: 10px;
  width: 100%;
  height: auto;
  padding: 10px;
  overflow-y: scroll;
}

.contHolder {
  position: relative;
  width: 100%;
  float: right;
  font-size: 14px;
}


}

#style-3::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

#style-3::-webkit-scrollbar {
  width: 4px;
  background-color: #f5f5f5;
}

#style-3::-webkit-scrollbar-thumb {
  background-color: #000000;
}

.nav-pills .nav-link.active {
  background-color: rgb(225, 84, 33);
}

a {
  color: black;
  text-decoration: none;
  background-color: transparent;
  text-decoration: none;
}

a:hover {
  color: rgb(225, 84, 33);
  text-decoration: none;
}

.nav {
  padding-bottom: 10px;
  border-bottom: 0.5px solid darkgray;
}
</style>
